var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70833 10.6036H2.29167C1.68408 10.603 1.10157 10.3613 0.671944 9.93169C0.242317 9.50207 0.000661737 8.91956 0 8.31197L0 2.8953C0.000661737 2.28772 0.242317 1.70521 0.671944 1.27558C1.10157 0.845955 1.68408 0.604299 2.29167 0.603638L7.70833 0.603638C8.31592 0.604299 8.89843 0.845955 9.32806 1.27558C9.75768 1.70521 9.99934 2.28772 10 2.8953V8.31197C9.99934 8.91956 9.75768 9.50207 9.32806 9.93169C8.89843 10.3613 8.31592 10.603 7.70833 10.6036ZM2.29167 1.85364C2.0154 1.85364 1.75045 1.96338 1.5551 2.15873C1.35975 2.35409 1.25 2.61904 1.25 2.8953V8.31197C1.25 8.58824 1.35975 8.85319 1.5551 9.04854C1.75045 9.24389 2.0154 9.35364 2.29167 9.35364H7.70833C7.9846 9.35364 8.24955 9.24389 8.4449 9.04854C8.64025 8.85319 8.75 8.58824 8.75 8.31197V2.8953C8.75 2.61904 8.64025 2.35409 8.4449 2.15873C8.24955 1.96338 7.9846 1.85364 7.70833 1.85364H2.29167ZM3.33 4.49489V6.71239C3.33 6.80995 3.35563 6.9058 3.40431 6.99035C3.45299 7.0749 3.52303 7.14518 3.6074 7.19416C3.69178 7.24314 3.78754 7.26911 3.8851 7.26945C3.98267 7.2698 4.07861 7.24452 4.16333 7.19614L6.38292 6.08739C6.46822 6.03867 6.53912 5.96827 6.58844 5.88331C6.63775 5.79835 6.66372 5.70187 6.66372 5.60364C6.66372 5.50541 6.63775 5.40892 6.58844 5.32396C6.53912 5.23901 6.46822 5.1686 6.38292 5.11989L4.16333 4.01114C4.07861 3.96276 3.98267 3.93748 3.8851 3.93782C3.78754 3.93817 3.69178 3.96413 3.6074 4.01311C3.52303 4.06209 3.45299 4.13237 3.40431 4.21692C3.35563 4.30147 3.33 4.39732 3.33 4.49489Z",
    fill: "#45185A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.603638)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsActive);
export default __webpack_public_path__ + "static/media/MeetingsActive.09aa0e6a702a60396bed4feb152f71dd.svg";
export { ForwardRef as ReactComponent };